import api from "./api";

// Capa de servicios API del dominio "contactos" (contacts) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Listados / lectura ---
export const listContacts = (params) => api.get("/contacts", { params });
export const listContactsSimple = (params) => api.get("/contacts/list", { params });
export const getContact = (contactId, config) =>
  api.get(`/contacts/${contactId}`, config);
export const getContactsCount = () => api.get("/contacts/count");

// --- CRUD ---
export const createContact = (payload) => api.post("/contacts", payload);
export const updateContact = (contactId, payload) =>
  api.put(`/contacts/${contactId}`, payload);
export const deleteContact = (contactId) => api.delete(`/contacts/${contactId}`);
export const deleteContacts = (contactIds) =>
  api.delete("/contacts/", { data: { contactIds } });
export const importContacts = () => api.post("/contacts/import");

// --- Foto ---
export const uploadContactPicture = (contactId, formData) =>
  api.post(`/contacts/${contactId}/picture`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// --- Perfil 360 ---
export const getContact360Messages = (contactId, config) =>
  api.get(`/contacts/${contactId}/360-messages`, config);
export const getContact360Summary = (contactId) =>
  api.get(`/contacts/${contactId}/360-summary`);
export const getContact360Timeline = (contactId, config) =>
  api.get(`/contacts/${contactId}/360-timeline`, config);
export const updateContactProfile360 = (contactId, payload) =>
  api.put(`/contacts/${contactId}/profile-360`, payload);

// Perfil ampliado de contacto (edición inline por campo).
export const updateContactProfileData = (contactId, payload) =>
  api.patch(`/contacts/${contactId}/profile-data`, payload);

// Importación masiva de contactos por archivo (subida multipart).
export const uploadContacts = (formData) =>
  api.post("/contacts/upload", formData);
